import React from 'react';
import Layout from '../../../layouts/index';
import DetailModal from '../components/modal/DetailModal';
import { useTranslation } from 'react-i18next';

const DetailSufferer = () => {
    const { t } = useTranslation();
    
    return (
        <Layout>
            <div className='space-y-5'>
                <h1 className='flex h-10 items-center justify-start text-xl md:text-2xl font-semibold'>{t('sufferer.detailTitle')}</h1>
                <DetailModal t={t} />
            </div>
        </Layout>
    );
};

export default DetailSufferer;
